import { describeFields } from '../common/fields';
import { LegacyTopicGroupSchema } from './schemas';

export const LEGACY_TOPIC_GROUP_FIELDS = describeFields(LegacyTopicGroupSchema, {
  id: {},
  subject: {},
  code: {},
  label: {},
  badgeLabel: {},
  color: {},
});
